
export function checkOverflow(elt: HTMLElement) {
    return elt.scrollHeight > elt.offsetHeight
}
